import { ListItemIcon, ListItemText as MuiListItemText } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from '@/feature/lang';
import type { AllTexts, Translation } from '@/feature/lang/types';
import { transitionIn } from '../Drawer/layout';
import { useRail } from '../Drawer/useRail';

interface ListItemContentProps {
  label: (texts: AllTexts) => Translation;
  icon: ReactNode;
  isSubItem?: boolean;
}

export const ListItemContent = ({
  label,
  icon,
  isSubItem = false,
}: ListItemContentProps) => {
  const { texts, translate } = useTranslation();
  const translatedLabel = translate(label(texts));
  const [rail] = useRail();

  return (
    <>
      <ListItemIcon
        sx={{
          ml: isSubItem ? 4 : 0,
          mr: 2,
          minWidth: '24px',
          color: 'inherit',
          transition: (theme) => transitionIn(theme, 'margin-left'),
          ...(rail && {
            ml: isSubItem ? '2px' : 0,
          }),
        }}
      >
        {icon}
      </ListItemIcon>
      <ListItemText text={translatedLabel} />
    </>
  );
};

const ListItemText = ({ text }: { text?: string }) => (
  <MuiListItemText
    slotProps={{
      primary: {
        variant: 'body2',
      },
    }}
    primary={text}
  />
);
